import { render, staticRenderFns } from "./MessageSpecialSituation.vue?vue&type=template&id=4c0cd1d1&scoped=true&"
import script from "./MessageSpecialSituation.vue?vue&type=script&lang=ts&"
export * from "./MessageSpecialSituation.vue?vue&type=script&lang=ts&"
import style0 from "./MessageSpecialSituation.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MessageSpecialSituation.vue?vue&type=style&index=1&id=4c0cd1d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0cd1d1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\vNextBuildV3\\29\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4c0cd1d1', component.options)
    } else {
      api.reload('4c0cd1d1', component.options)
    }
    module.hot.accept("./MessageSpecialSituation.vue?vue&type=template&id=4c0cd1d1&scoped=true&", function () {
      api.rerender('4c0cd1d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "VueApp/common/components/MessageSpecialSituation.vue"
export default component.exports